import type { CSSProperties, PaperProps } from "@mantine/core";

export type PaperSurfaceOptions = {
  color?: string;
  borderColor?: string;
  /** Gold left stripe. Omits the other borders so the stripe ends stay square. */
  leftAccent?: string;
};

function paperBorderStyle(surface: string, options?: PaperSurfaceOptions): CSSProperties {
  const borderColor = options?.borderColor ?? surface;

  if (options?.leftAccent) {
    return {
      borderTopWidth: 0,
      borderRightWidth: 0,
      borderBottomWidth: 0,
      borderLeft: `4px solid ${options.leftAccent}`,
    };
  }

  return {
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor,
  };
}

export function paperSurfaceStyle(surface: string, options?: PaperSurfaceOptions): CSSProperties {
  return {
    background: surface,
    ...(options?.color ? { color: options.color } : {}),
    ...paperBorderStyle(surface, options),
  };
}

export function paperSurfaceProps(surface: string, options?: PaperSurfaceOptions): PaperProps {
  const style = paperSurfaceStyle(surface, options);

  if (options?.leftAccent) {
    return { bg: surface, style };
  }

  return {
    bg: surface,
    withBorder: true,
    style,
  };
}
